import { makeStyles,useTheme } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
  root: {
    minHeight: 'calc(100% - 52px)',
    width: '100%',
    display: 'flex',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
      flexDirection: 'column',
      overflowX: 'hidden',
    }
  },
  content: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
      flexDirection: 'column'
    }
  },
  contentBox: {
    width: '600px',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
      
    }
  },
  loaderClassName: {
    width: '80px !important',
    height: '80px !important'
  }
  
}));
